<template>
    <div
        v-if="dataSource && dataSourceType == 'Reception'"
        :key="reception.id"
        class="p-relative"
    >
        
        <Toolbar 
            v-on:toolbar-button-click="onToolbarClick"  
        />

        <DocumentPanel
            :document-info="dataSource.Data.Object"
        />

        <v-tabs
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            class="tab-selector-panel"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>

            <v-tab 
                v-for="item in pages"
                :key="reception.id + item.FormId"
                @click="onTabClicked(item.FormId)"
            >
                <template v-if="item.Count < 0">
                    {{ item.Name }}
                </template> 
                <template v-else>
                    {{ item.Name }}
                    <span class="count" id="attachCounter">{{ item.Count }}</span>
                </template>   
            </v-tab>

        </v-tabs>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="reception.id + item.FormId"
            >

                <!--#region Карточка -->
                <template v-if="item.FormId == reception.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>

                            <!--#region Основная информация -->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                
                                <v-card-panel title="Услугополучатель">

                                    <!-- ФИО_заявителя -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("ФИО_заявителя")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="true" class="onlyReadData">
                                                <template v-if="reception.DeclarantFullName">
                                                    {{ reception.DeclarantFullName }}
                                                </template>
                                                <template v-else>
                                                    {{ $t("Не_указано") }}
                                                </template>
                                            </div>
                                    
                                            <template v-else>
                                                <v-text-field
                                                    :value="reception.DeclarantFullName"
                                                    @input="update({ property: 'Data.Object.Subject', value: $event})"
                                                    outlined
                                                    dense                                                    
                                                >
                                                </v-text-field>
                                            </template>
                                        </v-col>
                                     </v-row>

                                    <!-- ФИО ребенка -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("ФИО_ребенка")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="true" class="onlyReadData">
                                                <template v-if="reception.FullNameRecipient">
                                                    {{ reception.FullNameRecipient }}
                                                </template>
                                                <template v-else>
                                                    {{ $t("Не_указано") }}
                                                </template>
                                            </div>
                                            <v-text-field
                                                v-else
                                                :value="reception.FullNameRecipient"
                                                @input="update({ property: 'Data.Object.Place', value: $event })"
                                                outlined
                                                dense                                               
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- Автор -->
                                    <!-- <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Автор")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div class="onlyReadData">
                                                <v-employee-chip :id="reception.AuthorEmployeeId" :name="reception.AuthorName" />
                                            </div>
                                        </v-col>
                                    </v-row> -->
                                    
                                </v-card-panel>
                            </v-col>

                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                <v-card-panel title="Запись">

                                    <!-- Дата приема -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Дата_приема")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ formatDate(receptionDate) }}
                                            </div>
                                            <template v-else>
                                                <v-menu 
                                                    v-model="receptionDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="receptionDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            class="datepick-input"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="receptionDate"
                                                        @input="receptionDateMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                        :allowed-dates="allowedReceptionDates"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>

                                            </template>
                                        </v-col>
                                    </v-row>   
                                    
                                    <!-- Время приема -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Время_приема") }}</label>
                                        </v-col>
                                        <v-col  cols="12" sm="12" md="6">

                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{`${beginTime} - ${endTime}`}}
                                            </div>
                                            <div class="more-inputs-in-row" v-else>
                                                <vue-timepicker 
                                                    v-model="beginTime"
                                                    placeholder=' '
                                                    close-on-complete
                                                    auto-scroll
                                                    hide-clear-button
                                                    :class="!timeIsValid() ? 'time-empty':''"
                                                    hide-disabled-items
                                                    :hour-range="upperHourLimit > 0 ? [[ 8, upperMinutesLimit == 0 ? upperHourLimit - 1 : upperHourLimit ]] : [[8, 20]]"
                                                    :minute-interval="10"
                                                >
                                                    <template v-slot:clearButton>
                                                        <i class="fas fa-times"></i>
                                                    </template>
                                                </vue-timepicker>
                                                <span>-</span>
                                                <vue-timepicker 
                                                    v-model="endTime"
                                                    placeholder=' '
                                                    close-on-complete
                                                    auto-scroll
                                                    hide-clear-button
                                                    :class="!timeIsValid() ? 'time-empty':''"
                                                    hide-disabled-items
                                                    :hour-range="lowerHourLimit > 0 ? [[ lowerMinutesLimit == 50 ? lowerHourLimit + 1 : lowerHourLimit, 20 ]] : [[8, 20]]"
                                                    :minute-interval="10"
                                                >
                                                    <template v-slot:clearButton>
                                                        <i class="fas fa-times"></i>
                                                    </template>
                                                </vue-timepicker>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    
                                    <!-- Доступно для записи -->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Доступно_для_записи_с") }}</label>
                                        </v-col>
                                        <v-col  cols="12" sm="12" md="6">

                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ formatDateTime(reception.ActiveFrom) }}
                                            </div>
                                            <div class="more-inputs-in-row" v-else>
                                                <v-menu 
                                                    v-model="activeDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="activeDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            class="datepick-input flex-grow-1"
                                                            style="width:calc(100% + 36px)!important;"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="activeDate"
                                                        @input="activeDateMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                        :allowed-dates="allowedActiveDates"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                                <span class="miir-text-cap" style="width:4px;"></span>
                                                <vue-timepicker 
                                                    v-model="activeTime"
                                                    placeholder=' '
                                                    close-on-complete
                                                    auto-scroll
                                                    hide-clear-button
                                                    :class="!timeIsValid() ? 'time-empty':''"
                                                    hide-disabled-items
                                                    :hour-range="[[7, 20]]"
                                                    :minute-interval="10"
                                                >
                                                    <template v-slot:clearButton>
                                                        <i class="fas fa-times"></i>
                                                    </template>
                                                </vue-timepicker>
                                            </div>
                                        </v-col>
                                    </v-row>

                                </v-card-panel>
                            </v-col>

                            <!-- Заявление -->

                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                <v-card-panel title="Заявление">
                                    <v-row class="full-width-row" no-gutters>
                                        <v-col cols="12" sm="12" md="2">
                                            <label class="f-label">{{ $t("Заявление") }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="10">
                                            <div class="onlyReadData flex-wrap">
                                                <v-document-link 
                                                    v-if="reception.StatementId && reception.StatementName"
                                                    :isViewMode="true" 
                                                    :id="reception.StatementId" 
                                                    :type="'Chancellery|Documents|CitizenStatements.Document'" 
                                                    :text="reception.StatementName"                                                    
                                                />
                                                <template v-else>
                                                    {{ $t("Не_указано") }}
                                                </template>
                                            </div>
                                        </v-col>
                                    </v-row>  
                                </v-card-panel>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
            </v-tab-item>

        </v-tabs-items>
    </div>
</template>

<script>
import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';
import { mapActions, mapGetters } from 'vuex';
import sys from '@/services/system';
import _ from 'lodash';
import i18n from '@/i18n';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';

export default {
    name: "ReceptionScheduleCard",
    components: {
        Toolbar,
        DocumentPanel,
        VueTimepicker,
    },
    data() {
        return {
            tab: null,
            receptionDateMenu: false,
            activeDateMenu: false,
            requiredRules: [
                v => !!v || v === 0 || 'Поле_обязательно',
            ]
        }
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    computed: {
        //...mapGetters('qalaQyzmet/receptionSchedule/addMeetingQuestion', { isAddMeetingQuestionVisible: 'isVisible' }),
        
        //...mapGetters('qalaQyzmet/receptionSchedule/addProtocolLink', {isAddProtocolLinkVisible : 'isVisible' }),
        ...mapGetters('references', ['GetReference']),
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource', dataSourceType: 'getDataSourceType' }),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            integerNotNull: 'getIntegerNotNullRule',
            integerRule: 'getIntegerRule'
        }),
        reception() {
            return this.dataSource?.Data?.Object;
        },
        isViewMode() {
            return this.dataSource?.Data?.FormId == "1702021";
        },
        isProtocolLinked(){
            return this.reception.Protocol;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.reception.id, Name: this.$t("Карточка_приема") }
            ];

            //pages.push({ Count: this.reception.Questions.length, FormId: `MeetingAgenda`, Name: this.$t("Повестка") });
            // if (this.isViewMode) 
            //     pages.push({ Count: this.reception.AttachmentsSource?.length ?? 0, FormId: `MeetingAttachments`, Name: this.$t("Материалы_совещания") });
            if (this.isProtocolLinked)
                pages.push({ Count: -1, FormId: `Protocol`, Name: this.$t("Контроль") });

            return pages;
        },
        questionsSorted() {
            return this.$_(this.reception.Questions).orderBy(['Number'], ['asc']).value();
        },
        currentHeaders() {
            let headers = [
                //{ text: i18n.t("Номер_по_порядку"), value: 'Number', width: '150px', sortable: false },
                { text: i18n.t("Выступающий"), value: 'SpeakerName', width: '20%', sortable: false },
                { text: i18n.t("Текст_вопроса"), value: 'Subject', sortable: false },
                { text: i18n.t("Длительность,_мин"), value: 'Duration', align: 'center', width: '150px', sortable: false },
            ];

            if (!this.isViewMode) {
                headers.unshift({ text: '', value: 'Move', sortable: false, width: '49px' });
                headers.push({ text: '', value: 'Actions', sortable: false, width: '52px' });
            }

            return headers;
        },
        selectInitiatorTooltip() {
            return this.$t("Выбрать_инициатора");
        },
        selectSecretaryTooltip() {
            return this.$t("Выбрать_секретаря");
        },
        selectMembersTooltip() {
            return this.$t("Выбрать_участников");
        },
        addMeetingQuestionTooltip() {
            return this.$t("Добавить_вопрос");
        },
        getSelectInitiatorParam(){
            return this.getSelectPersonParam('Initiator');
        },
        getSelectSecretaryParam(){
            return this.getSelectPersonParam('Secretary');
        },
        getSelectMemberParam(){
            let selected = this.reception.Members?.map( member => member.WorkplaceId) ?? [];
            return { 
                title: i18n.t("Выбор_участников"),
                includeInner: true,
                includeOuter: true,
                multiple: true,
                selected
            }
        },
        //#region Даты, интервалы
        receptionDate: {
            get: function() {
                if (this.reception.Date)
                    return this.$moment(this.reception.Date).format('YYYY-MM-DD');
                
                return this.reception.Date;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.Date', value: `/Date(${Date.parse(newValue)})/` });
                //this.activeDate = newValue;
            }
        },
        beginTime: {
            get: function() {
                return this.reception.BeginTime ? this.$moment.utc(this.$moment.duration(this.reception.BeginTime).as('milliseconds')).format('HH:mm') : "08:00";
            },
            set: function(v) {
                this.updateSource({ property: 'Data.Object.BeginTime', value: this.$moment.duration(v + ':00').toJSON() });
                this.updateSource({ property: 'Data.Object.Subject', value: `${v} - ${this.endTime}` });
            }
        },
        endTime: {
            get: function() {
                return this.reception.EndTime ? this.$moment.utc(this.$moment.duration(this.reception.EndTime).as('milliseconds')).format('HH:mm') : "00:00";
            },
            set: function(v) {
                this.updateSource({ property: 'Data.Object.EndTime', value: this.$moment.duration(v + ':00').toJSON() });
            }
        },
        activeDate: {
            get: function() {
                if (this.reception.ActiveFrom)
                    return this.$moment(this.reception.ActiveFrom).format('YYYY-MM-DD');
                
                return this.reception.ActiveFrom;
            },
            set: function(newValue) {
                
                //console.log('utc', this.$moment("/Date(1748440800000+0500)/").utc().format('YYYY-MM-DD HH:mm:ss'), this.$moment("/Date(1748440800000+0500)/").format('YYYY-MM-DD HH:mm:ss'));


                if (!newValue) return;
                
                const currentTime = this.reception.ActiveFrom 
                    ? this.$moment(this.reception.ActiveFrom).format('HH:mm:ss')
                    : '08:00:00';
                
                const combinedDateTime = this.$moment(`${newValue} ${currentTime}`, 'YYYY-MM-DD HH:mm:ss');
                
                const clientOffset = this.getClientTimezoneOffset();

                this.updateSource({ 
                    property: 'Data.Object.ActiveFrom', 
                    value: `/Date(${combinedDateTime.valueOf()}${clientOffset})/` 
                });
            }
        },
        activeTime: {
            get: function() {
                if (this.reception.ActiveFrom) {
                    return this.$moment(this.reception.ActiveFrom).format('HH:mm');
                }
                return '08:00';
            },
            set: function(newValue) {
                if (!newValue) return;
                
                const currentDate = this.reception.ActiveFrom 
                    ? this.$moment(this.reception.ActiveFrom).format('YYYY-MM-DD')
                    : this.$moment().format('YYYY-MM-DD');
                
                const combinedDateTime = this.$moment(`${currentDate} ${newValue}:00`, 'YYYY-MM-DD HH:mm:ss');
                
                const clientOffset = this.getClientTimezoneOffset();

                this.updateSource({ 
                    property: 'Data.Object.ActiveFrom', 
                    value: `/Date(${combinedDateTime.valueOf()}${clientOffset})/` 
                });
            }
        },
        lowerHourLimit() {
            let hStr = this.beginTime.split(':')[0];
            return Number(hStr)
        },
        lowerMinutesLimit() {
            let mStr = this.beginTime.split(':')[1];
            return Number(mStr)
        },

        upperHourLimit() {
            let hStr = this.endTime.split(':')[0];
            return Number(hStr)
        },
        upperMinutesLimit() {
            let mStr = this.endTime.split(':')[1];
            return Number(mStr)
        },
        realEndTime() {
            return `${this.$moment(this.reception.Date).format('DD.MM.YYYY')} ${this.endTime}`;
        },
        meetingDuration() {
            let beginDateTime = this.$moment(this.beginTime, 'HH:mm');
            let endDateTime = this.$moment(this.endTime, 'HH:mm');

            let minutesDiff = endDateTime.diff(beginDateTime, 'minutes');

            let hourDuration = Math.floor(minutesDiff / 60);
            let minutesTail = minutesDiff % 60;

            let hoursLabel = "часов";

            if (hourDuration == 1)
                hoursLabel = "час";

            if (hourDuration > 1 && hourDuration < 5)
                hoursLabel = "часа";

            let minutesLabel = "минут";

            if (minutesTail == 1)
                minutesLabel = "минута";

            if (minutesTail > 1 && minutesTail < 5)
                minutesLabel = "минуты";
            
            if(minutesDiff > 0)
                return `${hourDuration} ${this.$t(hoursLabel)} ${minutesTail} ${this.$t(minutesLabel)}`;
            
            return '-';
        },
        agendaDuration() {
            let questionDurationMinutes = this.reception.Questions?.map(q => parseInt(q.Duration)).reduce((partialSum, a) => partialSum + a, 0) ?? 0;

            let hourDuration = Math.floor(questionDurationMinutes / 60);
            let minutesTail = questionDurationMinutes % 60;

            let hoursLabel = "часов";

            if (hourDuration == 1)
                hoursLabel = "час";

            if (hourDuration > 1 && hourDuration < 5)
                hoursLabel = "часа";

            let minutesLabel = "минут";

            if (minutesTail == 1)
                minutesLabel = "минута";

            if (minutesTail > 1 && minutesTail < 5)
                minutesLabel = "минуты";
            
            if(questionDurationMinutes > 0)
                return `${hourDuration} ${this.$t(hoursLabel)} ${minutesTail} ${this.$t(minutesLabel)}`;
            
            return '-';
        }
        //#endregion
    },
    methods: {
        ...mapActions('references', ['getReference']),
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),   
        onTabClicked (formId) {
            if (this.$refs[formId])
                this.$refs[formId][0]?.update();
        },
        async onToolbarClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => { return i.split('/')[2] });

            if (actions.includes(button.Action)) {

                if (button.Action == 'Save' || button.Action == 'SaveAndClose') {
                    let validate_result = this.$refs.form[0].validate();
                    
                    if (validate_result && this.timeIsValid())
                        await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
                    else
                        this.$notify.alert(i18n.t("Не_заполнены_обязательные_поля"));
                }
                else
                    await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
            }
            else
                this.$notify.alert(`Action ${button.Action} not emplemented`);
        },
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        formatDateTime (source) {
            return this.$moment(source).format('DD.MM.YYYY HH:mm');
        },
        timeIsValid() {
            let beginDateTime = this.$moment(this.beginTime, 'HH:mm');
            let endDateTime = this.$moment(this.endTime, 'HH:mm');
            let minutesDiff = endDateTime.diff(beginDateTime, 'minutes');
            return minutesDiff > 0;
        },
        getSelectPersonParam(role){
            let title = "";
            let selectedId = "";

            switch (role) {
                case 'Initiator':
                    title = "Выбор_инициатора";
                    selectedId = this.reception.InitiatorWorkplaceId;
                    break;

                case 'Secretary':
                    title = "Выбор_секретаря";
                    selectedId = this.reception.SecretaryWorkplaceId;
                    break;

                default: 
                    break;
            }

            return { 
                title: i18n.t(title),
                includeInner: true,
                includeOuter: true,
                multiple: false,
                selected: [ selectedId ]
            }
        },
        async onSelectPerson(role) {
            if (!role)
                return;
            
            try
            {
                let selectMemberParams = this.getSelectPersonParam(role);
                let { workplaceId, employeeId, name } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                this.onSetPerson(role, { workplaceId, employeeId, name });
            }
            catch(ex)
            {
                if (ex.message != "Cancelled")
                    console.error("Произошла непредвиденная ошибка");
                else
                    console.log("Cancelled"); 
            }
        },
        async onSelectInitiatorByChip(e){
            this.onSetPerson('Initiator', e.value);
        },
        async onDeleteInitiatorPerson(){
            this.onDeletePerson('Initiator');
        },
        async onSelectSecretaryByChip(e){
            this.onSetPerson('Secretary', e.value);
        },
        async onDeleteSecretaryPerson(){
            this.onDeletePerson('Secretary');
        },
        async onSetPerson(role, value){
            this.updateSource({ property: `Data.Object.${role}WorkplaceId`, value: value.workplaceId });
            this.updateSource({ property: `Data.Object.${role}EmployeeId`, value: value.employeeId });
            this.updateSource({ property: `Data.Object.${role}Name`, value: value.name });
        },
        async onDeletePerson(role){
            this.updateSource({ property: `Data.Object.${role}WorkplaceId`, value: null });
            this.updateSource({ property: `Data.Object.${role}EmployeeId`, value: null });
            this.updateSource({ property: `Data.Object.${role}Name`, value: null });
        },
        async onSelectMembers() {
            try
            {
                let selectMemberParams = this.getSelectMemberParam;
                let result = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                this.updateSource({ property: `Data.Object.Members`, value: result.map(x => ({ MeetingId: this.reception.id, Name: x.name, EmployeeId: x.employeeId, WorkplaceId: x.workplaceId, Status: 0 })) });
            }
            catch(ex)
            {
                if (ex.message != "Cancelled")
                    console.error("Произошла непредвиденная ошибка");
                else
                    console.log("Cancelled"); 
            }
        },
        async onSelectMemberByChip(e) {
            const member = { MeetingId: this.reception.id, Name: e.value.name, EmployeeId: e.value.employeeId, WorkplaceId: e.value.workplaceId, Status: 0 };
            let value = this.reception.Members ? [ ...this.reception.Members, member ] : [ member ];
            this.updateSource({ property: 'Data.Object.Members', value });
        },
        async onDeleteMember(id){
            let tmp = Array.from(this.reception.Members);
            let itemToRemove = tmp.find(x=>x.WorkplaceId == id);

            if (itemToRemove) {

                let questions = Array.from(JSON.parse(JSON.stringify(this.reception.Questions)));

                if (questions.find(x => x.SpeakerWorkplaceId == itemToRemove.WorkplaceId) != undefined) {
                    this.$notify.alert(i18n.t("Нельзя_удалить_участника-докладчика"));
                    return;
                }

                let index = tmp.indexOf(itemToRemove);
                
                if (index > -1) {
                    tmp.splice(index, 1);
                    this.updateSource({ property: 'Data.Object.Members', value: tmp });
                }
            }
        },
        // async onAddMeetingQuestion() {
        //     try {
        //         let result = await this.$store.dispatch('meetings/addMeetingQuestion/open', { members: this.reception.Members ?? [] });
        //         let questions = Array.from(JSON.parse(JSON.stringify(this.reception.Questions)));

        //         questions.push({
        //             MeetingId: this.reception.id,
        //             Number: questions.length + 1,
        //             Subject: result.subject,
        //             Duration: result.duration,
        //             SpeakerEmployeeId: result.speaker.SpeakerEmployeeId,
        //             SpeakerWorkplaceId: result.speaker.SpeakerWorkplaceId,
        //             SpeakerName: result.speaker.SpeakerName,
        //         });

        //         this.updateSource({ property: `Data.Object.Questions`, value: questions });
        //     }
        //     catch (ex) {
        //         console.log("Произошла_непредвиденная_ошибка");
        //     }
        // },
        async onEditQuestion(item) {

            let indexOfQuestion = this.reception.Questions.indexOf(item);

            if (indexOfQuestion < 0)
                return;

            let question = { 
                subject: item.Subject,
                duration: item.Duration,
                speaker: { 
                    SpeakerEmployeeId: item.SpeakerEmployeeId,
                    SpeakerWorkplaceId: item.SpeakerWorkplaceId,
                    SpeakerName: item.SpeakerName
                }
            };
            let result = await this.$store.dispatch('meetings/addMeetingQuestion/open', { members: this.reception.Members ?? [], question });
            let questions = Array.from(JSON.parse(JSON.stringify(this.reception.Questions)));

            questions[indexOfQuestion].Subject = result.subject;
            questions[indexOfQuestion].Duration = result.duration;
            questions[indexOfQuestion].SpeakerEmployeeId = result.speaker.SpeakerEmployeeId;
            questions[indexOfQuestion].SpeakerWorkplaceId = result.speaker.SpeakerWorkplaceId;
            questions[indexOfQuestion].SpeakerName = result.speaker.SpeakerName;

            this.updateSource({ property: `Data.Object.Questions`, value: questions });
        },
        onDeleteQuestion(item) {
            let indexOfQuestion = this.reception.Questions.indexOf(item);

            if (indexOfQuestion < 0)
                return;

            let questions = Array.from(JSON.parse(JSON.stringify(this.reception.Questions)));
            questions.splice(indexOfQuestion, 1);

            for (let i = 0; i < questions.length; i++) {
                questions[i].Number = i + 1;
            }

            this.updateSource({ property: `Data.Object.Questions`, value: questions });
        },
        onMoveQuestion(item, direction) {
            let idx = item.Number - 1;
            let targetIndex = direction == 'up' ? idx - 1 : idx + 1;
            let questions = Array.from(JSON.parse(JSON.stringify(this.reception.Questions)));
            let tmp = questions[targetIndex];
            questions[targetIndex] = questions[idx];
            questions[idx] = tmp;

            for (let i = 0; i < questions.length; i++) {
                questions[i].Number = i + 1;
            }

            this.updateSource({ property: `Data.Object.Questions`, value: questions });
        },
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250),
        getClientTimezoneOffset: function() {
            const offset = new Date().getTimezoneOffset();
            const hours = Math.floor(Math.abs(offset) / 60);
            const minutes = Math.abs(offset) % 60;
            const sign = offset <= 0 ? '+' : '-';
            
            return `${sign}${hours.toString().padStart(2, '0')}${minutes.toString().padStart(2, '0')}`;
        },
        allowedActiveDates(val) {
            return this.$moment(val, 'YYYY-MM-DD').isSameOrAfter(this.$moment(), 'day');
        },
        allowedReceptionDates(val) {
            return this.$moment(val, 'YYYY-MM-DD').isSameOrAfter(this.$moment(), 'day');
        }
    },

    async created() {        
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form?.[0]?.validate();
        }  
    }
}
</script>